<form [formGroup]="frm" class="formGroup personalForm">
  <mat-form-field>
    <mat-label>Nombre</mat-label>
    <input matInput formControlName="name"/>
    @if(name.hasError('required')){
    <mat-error> Campo requerido </mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Apellidos</mat-label>
    <input matInput formControlName="lastname"/>
    @if(lastname.hasError('required')){
    <mat-error> Campo requerido </mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Email</mat-label>
    <input matInput formControlName="email" />
    @if(email.hasError('required')){
    <mat-error>Campo requerido</mat-error>
    } @else if(email.hasError('pattern')){
    <mat-error>Formato de correo incorrecto</mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Número telefónico</mat-label>
    @if(phone.errors){
      <mat-hint>Formato requerido: 8 números (55678678)</mat-hint>
    }
    <input matInput formControlName="phone" maxlength="8"/>
    @if(phone.hasError('required')){
    <mat-error>Campo requerido</mat-error>
    } @else if(phone.hasError('pattern')){
    <mat-error>Formato requerido: 8 números</mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Fecha de nacimiento</mat-label>
    <input matInput [matDatepicker]="_birthday" formControlName="birthday" [max]="maxDate"/>
    <mat-datepicker-toggle
      matIconSuffix
      [for]="_birthday"
    ></mat-datepicker-toggle>
    <mat-datepicker #_birthday></mat-datepicker>
    @if(birthday.hasError('required')){
    <mat-error> Campo requerido </mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Carnet o pasaporte</mat-label>
    @if(dni.errors){
      <mat-hint>Formato: 11 números o una letra con 6 números</mat-hint>
    }
    <input matInput formControlName="dni" maxlength="11"/>
    @if(dni.hasError('required')){
    <mat-error> Campo requerido </mat-error>
    } @else if(dni.hasError('pattern')){
    <mat-error>
      Formato requerido: Una letra y 6 números, o 11 números
    </mat-error>
    }
  </mat-form-field>

  <t-llevo-image-input #image formControlName="photo"></t-llevo-image-input>
</form>
